export const ADMIN_JWT_KEY = 'adminJwt';
export const ADMIN_STATE_KEY = 'adminState';

export function isAccountSwitched() {
  return !!localStorage.getItem(ADMIN_JWT_KEY);
}

export function startAccountSwitch(authData) {
  const currentJwt = localStorage.getItem('jwt');
  const currentState = localStorage.getItem('state');

  if (!isAccountSwitched()) {
    if (!currentJwt || !currentState) {
      return false;
    }
    localStorage.setItem(ADMIN_JWT_KEY, currentJwt);
    localStorage.setItem(ADMIN_STATE_KEY, currentState);
  }

  localStorage.setItem('jwt', authData.jwt);
  localStorage.setItem('state', JSON.stringify(authData));
  return true;
}

export function stopAccountSwitch() {
  const adminJwt = localStorage.getItem(ADMIN_JWT_KEY);
  const adminState = localStorage.getItem(ADMIN_STATE_KEY);

  if (!adminJwt || !adminState) {
    return false;
  }

  localStorage.setItem('jwt', adminJwt);
  localStorage.setItem('state', adminState);
  localStorage.removeItem(ADMIN_JWT_KEY);
  localStorage.removeItem(ADMIN_STATE_KEY);
  return true;
}

export function clearAccountSwitchSession() {
  localStorage.removeItem(ADMIN_JWT_KEY);
  localStorage.removeItem(ADMIN_STATE_KEY);
}

export function getAdminSession() {
  return {
    jwt: localStorage.getItem(ADMIN_JWT_KEY),
    state: localStorage.getItem(ADMIN_STATE_KEY),
  };
}
